import Form from '@form/Form';
import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';

export default class RecordCreateSubformVehicle extends Form {
  public mergeFormData(data: any): void {
    Object.assign(this.getData(), data);
  }

  public toRecordCreateSubform(identifier: string, parent: RecordCreateForm): void {
    this.toSubform(identifier, parent)
  }
}
